<template>
  <div class="container">
    <div class="contain_wrapper">
      <div class="left">
        <div class="book_img" v-if="leftItemDetail">
          <img :src="this.base_img + leftItemDetail[0].Id+'.gif'" alt="" class="img-btn" :onerror="IMG_DEFAULT_URL">
          <div class="reading-btn" @click="handleClickRead(leftItemDetail[0].Id)"><span class="iconfont reading-icon">&#xe612;</span>在线阅读</div>  
        </div>
        <div class="left_content" v-if="leftItemDetail" :id="leftItemDetail[0].Id">
          <p class="title">{{leftItemDetail[0].BookTitle | ellipsisTitle}}</p>
          <p class="content" v-if="leftItemDetail[0].Content">内容简介：{{leftItemDetail[0].Content | ellipsisContent}}</p>
          <p class="edit" v-if="leftItemDetail[0].Editorial">编纂人员：{{leftItemDetail[0].Editorial}}</p>
          <p class="content-time" v-if="leftItemDetail[0].Date">内容时限：{{leftItemDetail[0].Date}}</p>
        </div>
      </div>

      <div class="right" v-if="itemDetailList">
        <div class="headTop">
          <div class="directory" :class="{on: showDirectory}" @click="handleShowDirectory(true)">
            目录
          </div>
          <input :readonly="readonlyShow" @focus="focusHandle" v-model="innerKeyword" placeholder="书内检索" class="searchInput" @keyup.enter="handleClickSearch"/><span class="iconfont searchIcon" @click="handleClickSearch">&#xe63d;</span>
          <div class="book_search-btn" :class="{on: !showDirectory}" @click="handleShowDirectory(false)" v-show="showBookSearchBtn">
            书内检索
          </div>
        </div>
        <div class="content_inner" v-show="showDirectory">
          <div class="content_left">
            <div class="stoolbar-tree">
              <div class="stoolbar-tree-top"></div>
              <div class="stoolbar-tree-bottom"></div>
            </div>
            <div class="stoolbar-btn">
              <a href="javascript:;" class="stoolbar-btn-up" id="stoolbarBtnUp" title="向上翻页" @click="handleScrollUp"></a>
              <a href="javascript:;" class="stoolbar-btn-down" id="stoolBarBtnDown" title="向下翻页" @click="handleScrollDown"></a>
            </div>
            <div class="stoolbar-dir" ref="leftScroll">
              <ul id="stoolbarDir" > 
                <li :data-index="index" 
                  :class="{current: index===currentIndex}" 
                  @click="clickMenuItem(index)"
                  v-for="(item, index) of itemDetailList" :key="index"
                >
                  <h3 :ref="index">
                    <span class="stoolbar-dir-dot"></span>
                    <a href="javascript:;" class="zs_detail_title" :title="item.item.Title">{{item.item.Title | ellipsis}}</a>
                  </h3>
                </li>
              </ul>
            </div>
          </div>

          <div class="content_right" id="scrollDiv">
            <ul id="list" ref="contentUl">
              <li v-for="(itemArrs, index) of itemDetailList" :key="index" :id="index" class="conten-list">
                <span></span>
                <h3>
                  <i :class="{open : ShowItemList}" @click="isShowItemList($event)" v-show="itemArrs.subItemList"></i>
                  <img src="~imgs/icon-type-pdf.png" />
                  <a @click="handleClickItemRead(itemArrs.item.Id)">{{itemArrs.item.Title}}</a>
                </h3>
                <ul v-if="itemArrs.subItemList.length > 0" ref="showItemList">
                  <li v-for="(itemArr, index) of itemArrs.subItemList" :key="index">
                    <h3 class="secTitle">
                      <i :class="{open : ShowItemList}" @click="isShowItemList($event)" v-show="itemArr.subItemList"></i>
                      <img src="~imgs/icon-type-pdf.png">
                      <a @click="handleClickItemRead(itemArr.item.Id)">{{itemArr.item.Title}}</a>
                    </h3>

                    <ul v-if="itemArr.subItemList.length > 0" ref="showItemList">
                      <li v-for="(item, index) of itemArr.subItemList" :key="index">
                        <h3 class="thirTitle">
                          <img src="~imgs/icon-type-pdf.png">
                          <a @click="handleClickItemRead(item.item.Id)">{{item.item.Title}}</a>
                        </h3>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div class="content_search" v-show="!showDirectory">
          <div v-if="inneritemDetailList">
           
            <div v-for="(item, index) of this.inneritemDetailList" :key="index">
              <div class="searchItem">
                <p class="item-title">
                  {{(index+1) + (pageSize*(curPage-1))}}.
                  <span class=item-title v-html="item.Title_HL || item.Title"></span>
                </p>
                <div class="item_content" v-if="item.Content">
                  主要内容：
                  <p v-html="$options.filters.ellipsisInnerContent(item.Content_HL || item.Content)"></p>
                </div>
                <div class="btnpanel clearfix">
                  <div  class="handle-view" @click="handleClickItemRead(item.Id)"><span class="iconfont reading-icon">&#xe612;</span>阅读</div>
                  <div  class="handle-download" @click="handleClickItemDown(item.Id)"><span class="iconfont reading-icon">&#xe612;</span>下载</div>
                </div>
              </div>  
            </div>
              
            
          </div>
          <div class="searchWarn" v-else>
            <i class="wf-icon icon-information"></i>
            没有命中记录，请重试或修改检索表达式
          </div>
          <div class="pagination_position" v-show="true">
            <Pagination
              :total= this.hit
              :currentPage= getCurrentPage
              :pageSize= this.pageSize
              :totalPage = this.totalPage
              @handleCurrentChangeSub="handleCurrentChangeSub"
            ></Pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '@/common/Pagination' 
import BScroll from 'better-scroll'
import {reqSearch, reqItemList, reqInnerItemList} from '../../api'
import {mapState} from 'vuex'
import {READ_URL, RESOURCE_TYPE_ITEM_READ, RESOURCE_TYPE_READ, LOGIN_IN_URL, RESOURCE_TYPE_ITEM_DOWN, IMG_BASE_URL, IMG_DEFAULT_URL} from '../../store/mutation-types'
export default {
  name: 'Detail',
  components: {
    Pagination
  },
  data () {
    return {
      showDirectory: true,
      IMG_DEFAULT_URL: IMG_DEFAULT_URL,
      base_img: IMG_BASE_URL,
      hit: 0,
      totalPage: 0,
      curPage:1,
      pageSize: 6,
      //ShowItemListIndex: 1,
      ShowItemList: true,
      innerKeyword: '',
      scrollY: 0, // 右侧滑动的Y轴坐标 (滑动过程时实时变化)
      tops: [], // 所有右侧分类li的top组成的数组  (列表第一次显示后就不再变化)
      food: {}, // 需要显示的food
      clickCurrentIndex: 0,
      showBookSearchBtn: false,
      leftItemDetail: '',
      itemDetailList: [],
      inneritemDetailList: [],
      readonlyShow: true
    }  
  },
  filters: {
    ellipsis(value) {
      if (!value) return;
      if (value.length > 10) {
        return value.slice(0, 10) + "...";
      }
      return value;
    },
    ellipsisTitle(value) {
      if (!value) return;
      if (value.length >18) {
        return value.slice(0,18) + "...";
      }
      return value;
    },
    ellipsisContent(value) {
      if (!value) return;
      if (value.length > 120) {
        return value.slice(0, 120) + "...";
      }
      return value;
    },
    ellipsisInnerContent(value) {
      if (!value) return;
      if (value.length > 90) {
        return value.slice(0, 90) + "...";
      }
      return value;
    }
  },
  computed: {
    ...mapState(['userinfo']),
    getCurrentPage() {
      const currentPage = this.$route.query.page
      if (currentPage) {
        return currentPage * 1
      } else {
        return 1
      }
    },
    // 滚动得到当前分类的下标
    currentIndex () { // 初始化和相关数据发生变化，执行
      // 得到条件数据
      const {scrollY, tops} = this
      // 根据条件计算产生一个结果
      const index = tops.findIndex((top, index) => {
        // scrollY >= 当前top && scrollY< 下一个top
        return scrollY >= top && scrollY < tops[index + 1]
      })
      if(scrollY > tops[tops.length-1]) {
        this.contentScroll.scrollTo(0, -(tops[tops.length-1]-43))
        this.clickCurrentIndex = tops.length-2
        return tops.length-2
      }
      // 返回结果
      this.clickCurrentIndex = index

      // 滚动左侧列表  /40
      this.$nextTick(()=> {
        
        if(index  >= tops.length - 8) {
          return
        }
        this.leftScroll.scrollTo(0, -40*index, 300)
      })
      //this.leftScroll.scrollTo(0, 40*(index+1), 300)
      //this.contentScroll.scrollTo(0, -scrollY, 300)

      return index
    }
  },
  async mounted() {
    this.curPage = this.$route.query.page || 1
    this._initBookInnerSearch(this.curPage)
    this.$loginAuthentication.intercept(0);
    const itemId =this.$route.query.BookID
    // 左侧itemDeital
    let opt = {
      fq: 'BookID:' + itemId,
      core: 'LocalChronicleOpera'
    }
    await reqSearch(opt).then(async (res) => {
      const data = res.resulter.results
      this.leftItemDetail = JSON.parse(data)
      opt = {
        fq: 'BookID:' + itemId
      }
      await reqItemList(opt).then((res) => {
        const data = res.resulter.extraData
        this.itemDetailList = JSON.parse(data).subItemList
        this.$nextTick (()=> {
          this._initScroll()
          this._initTops()
          this.$nextTick ( ()=> {
            if (this.$route.query.show == "false") {
              this.showBookSearchBtn = true
              this.showDirectory=false
            }
            if (this.$route.query.show == "true") {
              this.showBookSearchBtn = true
              this.showDirectory=true
            }
          })
        })
      })
    })
  },
  watch: {
    $route: {
      handler: function () {
        this.$loginAuthentication.intercept(0);
        this.curPage = this.$route.query.page || ''
        // this.curPage = this.$route.query.page ? Number(this.$route.query.page) : 1
        this._initBookInnerSearch(this.curPage)
      },
      deep: true
    }
  },
  methods: {
    // 初始化书内检索
    _initBookInnerSearch (pageNo) {
      this.innerKeyword = this.$route.query.queryInner || ''
      const opt = {
        core: 'LocalChronicleItemOpera',
        fq: 'BookID:' + this.$route.query.BookID,
        query: this.$route.query.queryInner || '',
        pageSize: 6,
        pageNo: pageNo
      }
      const inner_itme = reqInnerItemList(opt)
      inner_itme.then ((res) => {
        const data = res.resulter.results
        this.inneritemDetailList = JSON.parse(data)
        this.hit = res.resulter.hit;
        this.totalPage = res.resulter.totalPage
        this.pageSize = res.resulter.pageSize
      })
    },
    // 书内检索页码
    handleCurrentChangeSub (val) {
      if (this.$loginAuthentication.intercept(0)) {
        this.$router.push({path: 'detail', query: {BookID: this.$route.query.BookID, queryInner: this.innerKeyword || this.$route.query.queryInner, show: this.showDirectory, page: val}})
      }
    },
    // showDirectory 
    handleShowDirectory (boolean) {
      this.showDirectory=boolean
      const itemId = this.$route.query.BookID
      const queryInner = this.innerKeyword || this.$route.query.queryInner
      this.$router.push({path: 'detail', query: {BookID: itemId, queryInner: queryInner, show: boolean, page: this.curPage}})
    },
    // 书内检索
    handleClickSearch () {
      const itemId = this.$route.query.BookID
      if((this.innerKeyword).trim() === '') {
        alert('请输入检索词')
        return
      }
      const queryInner = this.innerKeyword || this.$route.query.queryInner
      // this.$router.push({path: 'detail', query: {BookID: itemId, queryInner: queryInner}})
      this.$router.push({path: 'detail', query: {BookID: itemId, queryInner: queryInner, show: 'false', page: this.curPage}})
      if (this.$route.query.queryInner) {
        this.showDirectory=false
        this.showBookSearchBtn = true
      }
      this._initBookInnerSearch()
    },
    // 志书阅读
    async handleClickRead (id) {
      if (await this.$loginAuthentication.intercept(0)) {
        // 整书 2
        this.$store.dispatch('savSourceType', 2)
        if(this.userinfo.users.length) {
          this.$store.dispatch('saveCurrentBookId', 0)
          this.$loginAuthentication.isAppleWechatOrQQ(READ_URL + id + RESOURCE_TYPE_READ)
        }else {
          let counter = 1
          this.$store.dispatch('saveCounter', counter)
          this.$store.dispatch('saveCurrentBookId', id)
          window.location.href = LOGIN_IN_URL + window.encodeURIComponent(window.location.href)
        }
      }
    },
    // 条目阅读
    async handleClickItemRead (id) {
      if (await this.$loginAuthentication.intercept(0)) {
        this.$store.dispatch('savSourceType', 1)
        if(this.userinfo.users.length) {
          this.$store.dispatch('saveCurrentBookId', 0)
          this.$loginAuthentication.isAppleWechatOrQQ(READ_URL + id + RESOURCE_TYPE_ITEM_READ)
        }else {
          let counter = 1
          this.$store.dispatch('saveCounter', counter)
          this.$store.dispatch('saveCurrentBookId', id)
          window.location.href = LOGIN_IN_URL + window.encodeURIComponent(window.location.href)
        }
      }
    },
    // 条目下载
    async handleClickItemDown (id) {
      if (await this.$loginAuthentication.intercept(0)) {
        this.$store.dispatch('savSourceType', 3)
        if(this.userinfo.users.length) {
          this.$store.dispatch('saveCurrentBookId', 0)
          this.$loginAuthentication.isAppleWechatOrQQ(READ_URL + id + RESOURCE_TYPE_ITEM_DOWN)
        }else {
          let counter = 1
          this.$store.dispatch('saveCounter', counter)
          this.$store.dispatch('saveCurrentBookId', id)
          window.location.href = LOGIN_IN_URL + window.encodeURIComponent(window.location.href)
        }
      }
    },
    // ajax 获取数据
    getData (opt) {
      const itemDetail = reqSearch(opt)
      itemDetail.then( (res) => {
      const data = res.resulter.results
      const list = JSON.parse(data)
      return list
      })
    },
    // 初始化滚动
    _initScroll () {
       // 列表显示后创建
      this.leftScroll = new BScroll('.stoolbar-dir', {
        probeType: 2,
        click: true,
        mouseWheel: true,
        resizePolling: 60
      })
     
      this.contentScroll = new BScroll('.content_right', {
        probeType: 2,  // 因为惯性滑动不会触发
        click: true,
        mouseWheel: true,
        resizePolling: 60
      })

      // 给右侧列表绑定scroll监听
      this.contentScroll.on('scroll', ({x, y}) => {
        this.scrollY = Math.abs(y)
        
        //this.leftScroll.scrollTo(-scrollY)
      })
      // 给右侧列表绑定scroll结束监听
      this.contentScroll.on('scrollEnd', ({x, y}) => {
        this.scrollY = Math.abs(y)
      })
    },
    //初始化tops
    _initTops () {
      // 1.初始化tops
      const tops = []
      let top = 0
      tops.push(top)
      // 2.收集
      // 找到所有分类li
      const lis = this.$refs.contentUl.children
      // console.dir(this.$refs.contentUl)
      // 伪数组转化真数组
      Array.prototype.slice.call(lis).forEach(li => {
        top += li.clientHeight
        tops.push(top)
      })
      // 3.更新数据
      this.tops = tops
    },
    //
    clickMenuItem (index) {
      // 使用右侧列表滑动到对应的位置
      const scrollY = this.tops[index]
      // 立即更新ScrollY
      this.scrollY = scrollY
      // 平滑互动右侧列表
      this.contentScroll.scrollTo(0, -scrollY, 300)
      //this.leftScroll.scrollTo(0, -scrollY, 300)
    },
    handleCurrentChange () {

    },
    // 向上滑动
    handleScrollUp () {
      if(this.clickCurrentIndex){
        this.clickCurrentIndex = this.clickCurrentIndex - 1
        this.clickMenuItem (this.clickCurrentIndex)
      }
    },
    // 向下滑动
    handleScrollDown () {
      const length = this.tops.length
      if(this.clickCurrentIndex < this.tops.length - 2){
        this.clickCurrentIndex = this.clickCurrentIndex + 1
        this.clickMenuItem (this.clickCurrentIndex)
      }
    },
    // 显示隐藏itemList
    isShowItemList (e) {
      　e.target.classList.toggle("open")
        $(e.target).parent().next().toggle()
        this._initTops()
    },
    async focusHandle() {
      this.readonlyShow = true
      if (await this.$loginAuthentication.intercept(1)) {
        this.readonlyShow = false
      } else {
        this.$message.warning('请先登录账号！')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.pagination_position {
  position: absolute;
  left: -124px;
  top: 555px;
}
.contain_wrapper {
  box-sizing: border-box;
  margin: 0 auto;
  height: 735px;
  width: 1200px;
  padding: 32px 0 42px 0;
  .left {
    width: 258px;
    height: 660px;
    border: 1px solid #dbcfc8;
    background: #f2eeeb;
    display: inline-block;
    .left_content {
      margin: 0 auto;
      width: 220px;
      color: #333333;
      font-size: 14px;
      p {
        margin: 8px 0;
      }
      .title {
        font-size: 18px;
        margin: 20px 0;
      }
      .content {
        font-size: 14px;
      }
      .edit {
        margin: 28px 0;
        font-size: 14px;
      }
    }
    .book_img {
      margin: 0 auto;
      width: 220px;
      border-bottom: 1px solid #dbcfc8;
      padding-top: 28px;
      padding-bottom: 20px;
      
      .img-btn {
        margin: 0 auto;
        display: block;
        width: 160px;
        height: 222px;
        border: 2px solid #dbcfc8;
      }
      .reading-btn{
        height: 36px;
        width: 128px;
        background: #a31f24;
        color: #ffffff;
        border-radius: 25px;
        text-align: center;
        line-height: 36px;
        margin: 0 auto;
        margin-top: 18px;
        font-size: 14px;
        cursor: pointer;
        .reading-icon {
          margin-right: 6px;
        }
      }
    }
  }
  .secTitle {
    padding-left: 50px;
  }
  .thirTitle {
     padding-left: 100px;
  }
  .firtitle {
    padding-left: 6px;
  }
  .right {
    width: 910px;
    height: 658px;
    border-top: none;
    float: right;
    //padding: 10px 0 0 20px; 
    #list {
      padding-left: 20px;
      padding-right: 20px;
    }
    ul#list {
      //padding-top: 10px;
      //padding-left: 20px;
      font-size: 14px;
      height: 99999px;
      h3 {
        height: 42px;
        border-bottom: 1px dotted #e2d7d1;
        line-height: 42px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        display: block;
        img {
          margin-left:4px; 
        }
        
      }
    }
    i.open {
      background-image: url(~imgs/icon-tree-opened.png);
    }
    i {
      display: inline-block;
      height: 16px;
      width: 16px;
      background: url(~imgs/icon-tree-closed.png) no-repeat;
      line-height: 16px;
      cursor: pointer;
      position: relative;
      top: 3px;
    }
    .headTop {
      width: 910px;
      height: 40px;
      background: #fff;
      position: relative;
      div {
        cursor: pointer;
      }
      .on {
        background: #94491f;
        color: #fff;
      }
      .directory{
        width: 144px;
        height: 40px;
        //background: #94491f;
        //color: #fff;
        line-height: 40px;
        text-align: center;
        font-size: 16px;
        border-radius: 3px 3px 0 0;
        float: left;
        background: #e5e5e5;
        color: #333333;
        &.on {
          background: #94491f;
          color: #fff;
        }
      }
      .book_search-btn {
        width: 144px;
        height: 40px;
        background: #e5e5e5;
        color: #333333;
        line-height: 40px;
        text-align: center;
        font-size: 16px;
        border-radius: 3px 3px 0 0;
        float: left;
        margin-left: 10px;
        &.on {
          background: #94491f;
          color: #fff;
        }
      }
      .searchInput {
        float: right;
        box-sizing: border-box;
        width: 198px;
        height: 30px;
        border: 1px solid #dbcfc8;
        line-height: 30px;
        border-radius: 1px;
        padding-left: 10px;
        font-size: 14px;
      }
      .searchIcon {
        position: absolute;
        right: 5px;
        top: 5px;
        color: #94491f;
        font-size: 20px;
        cursor: pointer;
      }
    }
    .content_inner {
      height: 620px;
      width: 910px;
      border: 1px solid #dbcfc8;
      position: relative;
      .content_left {
        width: 270px;
        height: 100%;
        background: #f9f9f9;
        float: left;
        position: relative;
        // left: 28px;
        // top: 40px;
        .stoolbar-tree {
          border-left: 1px #ddd solid;
          border-right: 1px #ccc solid;
          height: 470px;
          position: absolute;
          left: 28px;
          top: 40px;
          .stoolbar-tree-top {
            background: url(~imgs/sprite.png) no-repeat 0 0;
            height: 10px;
            overflow: hidden;
            position: absolute;
            width: 10px;
            left: -5px;
            bottom: 0;
          }
          .stoolbar-tree-bottom{
            background: url(~imgs/sprite.png) no-repeat 0 0;
            height: 10px;
            overflow: hidden;
            position: absolute;
            width: 10px;
            left: -5px;
          }
        }
        .stoolbar-btn {
          position: absolute;
          right: 20px;
          top: 40px;
          z-index: 100;
          .stoolbar-btn-up {
            background: url(~imgs/sprite.png) no-repeat;
            display: block;
            height: 25px;
            width: 22px;
            background-position: -80px 0;
            &:hover {
              background-position: -50px 0;
            }
          }
          .stoolbar-btn-down {
            background: url(~imgs/sprite.png) no-repeat;
            display: block;
            height: 25px;
            width: 22px;
            background-position: -80px -25px;
            &:hover {
              background-position: -50px -25px;
            }
          }
        }
        .stoolbar-dir {
          height: 450px;
          overflow: hidden;
          position: relative;
          left: 0;
          top: 8px;
          width: 230px;
          padding-left: 10px;
          margin-top: 42px;
          ul {
            position: absolute;
            left: 28px;
            font-size: 14px;
          }
          .current {
            h3 {
              position: relative;
              .stoolbar-dir-dot {
                background: url(~imgs/spriteTo.png) no-repeat;
                height: 16px;
                width: 26px;
                position: absolute;
                top: 12px;
                left: -10px;
              }
            }
            
          }
          .stoolbar-dir-dot {
            height: 40px;
            line-height: 40px;
            position: absolute;
            left: -4px;
            overflow: hidden;
            width: 10px;
            background: url(~imgs/sprite.png) no-repeat 0 -34px;
          }
          .zs_detail_title {
            height: 40px;
            display: block;
            line-height: 40px;
            margin-left: 20px;
            width: 176px;
          }
        }
      }
      .content_right {
        height: 610px;
        //height: 1200px;
        width: 640px;
        background: #ffffff;
        float: right;
        overflow: hidden;
        padding-top: 1px;
      }
    }
    
  }
}
.content_search {
  border: 1px solid #dbcfc8;
  height: 620px;
  position: relative;
  padding-top: 20px;
  overflow: hidden;
  .searchItem {
    margin: 0 auto;
    box-sizing: border-box;
    height: 87px;
    display: inline-block;
    border-bottom: 1px solid #dbcfc8;
    width: 858px;
    margin-left: 26px;
    min-height: 70px;
    padding: 8px 130px 8px 0;
    position: relative;
    .item-title {
      line-height: 31px;
      display: inline-block;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      vertical-align: bottom;
    }
    .item_content {
      line-height: 24px;
      color: #666;
      height: 48px;
      font-size: 14px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      p {
        display: inline;
      }
    }
    .btnpanel {
      position: absolute;
      display: block;
      float: none;
      top: -8px;
      right: 0;
      div {
        height: 30px;
        width: 95px;
        background: #a31f24;
        color: #ffffff;
        border-radius: 25px;
        text-align: center;
        line-height: 30px;
        margin: 0 auto;
        margin-top: 14px;
        font-size: 14px;
        cursor: pointer;
        span {
          margin-right: 3px;
        }
      }
    }
  }
  .searchWarn {
    font-size: 16px;
    text-align: center;
    line-height: 500px;
    i{
      margin: 0 5px;
      vertical-align: baseline;
    }
    .wf-icon {
      font-family: "wf-icon" !important;
      font-size: 16px;
      font-style: normal;
      -webkit-font-smoothing: antialiased;
    }
  }
  
}
</style>


// WEBPACK FOOTER //
// src/pages/detail/Detail.vue